"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextMenuHeader = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const use_t_1 = require("use-t");
const ContextHeader_1 = require("../ContextHeader");
const context_1 = require("./context");
const useBehaviorSubject_1 = require("../../../hooks/useBehaviorSubject");
const BasicButtonBack_1 = require("../../../2-inline-block/BasicButton/BasicButtonBack");
const Breadcrumbs_1 = require("../../../3-list-item/Breadcrumbs");
const Flex_1 = require("../../../3-list-item/Flex");
const ContextPaneHeaderSep_1 = require("../ContextPaneHeaderSep");
const ContextMenuHeader = (props) => {
    const [t] = (0, use_t_1.useT)();
    const state = (0, context_1.useContextMenu)();
    const path = (0, useBehaviorSubject_1.useBehaviorSubject)(state.path$);
    const menu = (0, useBehaviorSubject_1.useBehaviorSubject)(state.menu$);
    const crumbs = [
        ...path.map((item, index) => (React.createElement(Breadcrumbs_1.Breadcrumb, { key: item.id ?? item.name, compact: true, onClick: () => state.selectInPath(index) }, !index ? '~' : t(item.name)))),
        React.createElement(Breadcrumbs_1.Breadcrumb, { key: menu.id ?? menu.name, compact: true }, t(menu.name)),
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(ContextHeader_1.ContextHeader, { compact: true },
            React.createElement(Flex_1.Flex, { style: { alignItems: 'center' } },
                React.createElement(BasicButtonBack_1.BasicButtonBack, { onClick: state.selectBack }),
                React.createElement(Breadcrumbs_1.Breadcrumbs, { compact: true, crumbs: crumbs, style: { padding: '0 0 0 2px' } }))),
        React.createElement(ContextPaneHeaderSep_1.ContextPaneHeaderSep, null)));
};
exports.ContextMenuHeader = ContextMenuHeader;
